import type { pluginSlotViewer, SlotViewerIntegration } from '@wix/ricos';
import { FORMS_INTEGRATION_TYPE } from '@wix/communities-blog-client-common';
import FormSlotViewerBlock from './form-slot-viewer-block';

type ViewerSlotConfig = NonNullable<Parameters<typeof pluginSlotViewer>[0]>;
type SlotErrorHandler = NonNullable<ViewerSlotConfig['onError']>;

// The block ships with the ricos viewer, like every other plugin's viewer component: the
// server renders the wrapper and the sized placeholder without fetching anything. Only the Wix
// Forms renderer is lazy (see `form-renderer.ts`), and only in the browser.
const formsIntegration: SlotViewerIntegration = {
  Component: FormSlotViewerBlock,
};

/**
 * The viewer slot plugin config. Memoise the result on the caller side: the ricos viewer wrapper
 * is a PureComponent and builds its plugins from it.
 */
export const createFormsSlotViewerConfig = (onError?: SlotErrorHandler): ViewerSlotConfig => ({
  integrations: { [FORMS_INTEGRATION_TYPE]: formsIntegration },
  onError,
});
